import { render, staticRenderFns } from "./AheadBusinessClientNav.vue?vue&type=template&id=19b6174e&"
import script from "./AheadBusinessClientNav.vue?vue&type=script&setup=true&lang=ts&"
export * from "./AheadBusinessClientNav.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports